export const appointments = [

    {
      title: "Clause Belford",
      startDate: new Date(2018, 6, 5, 14, 0),
      endDate: new Date(2018, 6, 5, 14, 30),
      id: 2,
      location: "Room 5",
      color: "#E6E6E6"
  }, {
      title: "Elija Meson",
      startDate: new Date(2018, 6, 5, 15, 0),
      endDate: new Date(2018, 6, 5, 15, 30),
      id: 3,
      location: "Room 5",
      color: "#E6E6E6"
    },
    {
      title: "Phil Belford",
      startDate: new Date(2018, 6, 5, 13, 0),
      endDate: new Date(2018, 6, 5, 13, 30),
      id: 1,
    priorityId: 1,
    typeId: 1,
      location: "Room 2",
      color: "#BDECB6"
    },
    {
      title: "Stifen Ja",
      startDate: new Date(2018, 6, 5, 13, 0),
      endDate: new Date(2018, 6, 5, 13, 30),
      id: 4,
      location: "Room 5",
      color: "#9999CC"
    },
    {
      title: "Demon Black",
      startDate: new Date(2018, 6, 5, 16, 30),
      endDate: new Date(2018, 6, 5, 17, 0),
      id: 5,
      location: "Room 5",
      color: "#9999CC"
    }
];
